import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material'
import React from 'react'

import Button from '@/components/Button'

interface DeleteCustomLabelConfirmDialogProps {
  open: boolean
  labelName: string
  onConfirm: () => void
  onCancel: () => void
  isLoading?: boolean
}

export default function DeleteCustomLabelConfirmDialog({
  open,
  labelName: _labelName,
  onConfirm,
  onCancel,
  isLoading = false,
}: DeleteCustomLabelConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            bgcolor: '#2d2d2d',
            borderRadius: '8px',
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            marginTop: '5.625rem',
            height: 'auto',
          },
        },
      }}
    >
      <DialogTitle sx={{ py: 2.5, px: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography fontWeight={700} fontSize="1.15rem" color="white">
            Delete Custom Label
          </Typography>
          <IconButton
            onClick={onCancel}
            aria-label="close delete label dialog"
            sx={{ p: 0, '&:hover': { bgcolor: 'rgba(255,255,255,0.08)' } }}
          >
            <CloseIcon sx={{ color: 'white', fontSize: 20 }} />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ py: 2, px: 3, paddingTop: '4px !important' }}>
        <Typography
          sx={{
            color: 'rgba(255,255,255,0.87)',
            fontSize: '14px',
            lineHeight: 1.7,
          }}
        >
          Are you sure you want to delete the custom label?
          <br />
          Deleted labels will be taken away from the previously linked images.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ py: 2, px: 3 }}>
        <Box display="flex" justifyContent="flex-end" gap={1.5} width="100%">
          <Button
            id="delete-label-cancel-btn"
            label="CANCEL"
            variant="outlined"
            textTransform="uppercase"
            disabled={isLoading}
            onClick={onCancel}
          />
          <Button
            id="delete-label-confirm-btn"
            label="DELETE"
            variant="contained"
            color="primary"
            textTransform="uppercase"
            disabled={isLoading}
            loading={isLoading}
            onClick={onConfirm}
          />
        </Box>
      </DialogActions>
    </Dialog>
  )
}
